export default {
    meta: {
        title: '审批结果'
    }
};
